<template>
  <div class="keyboard">
    <div class="input-box" @click.stop="clickShowKeyboard">
      <li :class="type === 'HKorMacao' ? 'nobg' : ''">{{ first }}</li>
      <li :class="type === 'HKorMacao' ? 'nobg' : ''">{{ numArr[0] }}</li>
      <li>{{ numArr[1] }}</li>
      <li>{{ numArr[2] }}</li>
      <li>{{ numArr[3] }}</li>
      <li>{{ numArr[4] }}</li>
      <li v-if="type === 'normal' || type === 'newEnergy'">{{ numArr[5] }}</li>
      <li v-if="type === 'newEnergy'">{{ numArr[6] }}</li>
      <li class="HKorMacao" v-if="type === 'HKorMacao'">
        <span
          @click.stop="ChangeHKorMacaoActype(1)"
          :class="HKorMacaoActype == 1 ? 'active' : ''"
          >港</span
        >
        <span
          @click.stop="ChangeHKorMacaoActype(2)"
          :class="HKorMacaoActype == 2 ? 'active' : ''"
          >澳</span
        >
      </li>
    </div>
    <!-- 选择车牌号 首个汉字键盘 弹出层 -->
    <div class="plate_number">
      <van-popup
        v-model="show_chinese"
        position="bottom"
        :overlay="true"
        overlay-class="displayNone"
      >
        <div class="recent-blk">
          <div class="recent-blk-text1">
            <div>近期使用过：</div>
            <div><i class="el-icon-caret-bottom"></i></div>
          </div>
          <div class="recent-scroll">
            <nav>
              <div
                v-for="(item, index) in recentUseArr"
                :key="index"
                @click="setRecentUseValue(item)"
              >
                {{ item }}
              </div>
            </nav>
          </div>
        </div>
        <div class="plate_chinese_box">
          <!-- 点击对应的汉字，进行输入 -->
          <!-- <van-button
            size="small"
            v-for="(item, index) in ChineseList"
            :key="index"
            @click.stop="checkChinese(index)"
            style="vertical-align: top;"
          >
            <span v-if="item.id === 99"
              ><img
                src="./delete.png"
                style="vertical-align: middle;width: 6vw;"
            /></span>
            <span v-else>{{ item.name }}</span>
          </van-button> -->
          <!-- <div class="close-box" @click.stop="close_keyboard">
            <van-icon name="close" />
          </div> -->
          <div class="plate_number_box">
            <div
              size="small"
              v-for="(item, index) in ChineseList"
              :key="index"
              @click.stop="checkChinese(index)"
              class="btn-div btn-zh"
            >
              <div style="width: 100%;">
                <img
                  src="./delete.png"
                  style="vertical-align: middle;width: 30px;"
                  v-if="item.id === 99"
                />
                <span v-else>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 英文 数字 键盘 -->
    <div class="allBoard">
      <van-popup
        v-model="show_allBoard"
        position="bottom"
        :overlay="true"
        overlay-class="displayNone"
      >
        <div class="recent-blk">
          <div class="recent-blk-text1">
            <div>近期使用过：</div>
            <div><i class="el-icon-caret-bottom"></i></div>
          </div>
          <div class="recent-scroll">
            <nav>
              <div
                v-for="(item, index) in recentUseArr"
                :key="index"
                @click="setRecentUseValue(item)"
              >
                {{ item }}
              </div>
            </nav>
          </div>
        </div>
        <div class="plate_number_box">
          <!-- 点击对应的字母或数字，进行输入 -->
          <!-- <van-button
            size="small"
            v-for="(item, index) in English_Number"
            :key="index"
            @click.stop="checkEnglish_num(index)"
            style="vertical-align: top;"
          >
            <span v-if="item.id === 99"
              ><img
                src="./delete.png"
                width="100%"
                style="vertical-align: middle;"
            /></span>
            <span v-else>{{ item.name }}</span>
          </van-button> -->
          <!-- <div class="close-box" @click.stop="close_keyboard">
            <van-icon name="close" />
          </div> -->
          <div
            size="small"
            v-for="(item, index) in English_Number"
            :key="index"
            @click.stop="checkEnglish_num(index)"
            class="btn-div btn-en"
          >
            <div style="width: 100%;">
              <img
                src="./delete.png"
                style="vertical-align: middle;width: 30px;"
                v-if="item.id === 99"
              />
              <span v-else>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type", "showRecentUse", "licenseValue", "disabled"],
  data() {
    return {
      recentUseArr: [],
      showKeyboard: true, //车牌号输入框是否聚焦
      show_chinese: false, //是否显示汉字键盘
      show_allBoard: false, //是否显示英文数字键盘
      nullArray: ["", "", { name: "←", id: 99 }],
      speStyle: "top: -4px;",
      ChineseList: [
        { name: "京", id: 1 },
        { name: "津", id: 2 },
        { name: "冀", id: 3 },
        { name: "晋", id: 4 },
        { name: "蒙", id: 5 },
        { name: "辽", id: 6 },
        { name: "吉", id: 7 },
        { name: "黑", id: 8 },
        { name: "沪", id: 9 },
        { name: "苏", id: 10 },
        { name: "浙", id: 11 },
        { name: "皖", id: 12 },
        { name: "闽", id: 13 },
        { name: "赣", id: 14 },
        { name: "鲁", id: 15 },
        { name: "豫", id: 16 },
        { name: "鄂", id: 17 },
        { name: "湘", id: 18 },
        { name: "粤", id: 19 },
        { name: "桂", id: 20 },
        { name: "琼", id: 21 },
        { name: "渝", id: 22 },
        { name: "川", id: 23 },
        { name: "贵", id: 24 },
        { name: "云", id: 25 },
        { name: "藏", id: 26 },
        { name: "陕", id: 27 },
        { name: "甘", id: 28 },
        { name: "青", id: 29 },
        { name: "宁", id: 30 },
        { name: "新", id: 31 },
        { name: "", id: "" },
        { name: "", id: "" },
        { name: "", id: "" },
        { name: "←", id: 99 }
      ],
      English_Number: [
        { name: "1", id: 28 },
        { name: "2", id: 29 },
        { name: "3", id: 30 },
        { name: "4", id: 31 },
        { name: "5", id: 32 },
        { name: "6", id: 33 },
        { name: "7", id: 34 },
        { name: "8", id: 35 },
        { name: "9", id: 36 },
        { name: "0", id: 37 },
        { name: "Q", id: 38 },
        { name: "W", id: 39 },
        { name: "E", id: 40 },
        { name: "R", id: 41 },
        { name: "T", id: 42 },
        { name: "Y", id: 43 },
        { name: "U", id: 44 },
        // { name: "I", id: 45 },
        // { name: "O", id: 46 },
        { name: "P", id: 47 },
        { name: "A", id: 48 },
        { name: "S", id: 49 },
        { name: "D", id: 50 },
        { name: "F", id: 51 },
        { name: "G", id: 52 },
        { name: "H", id: 53 },
        { name: "J", id: 54 },
        { name: "K", id: 55 },
        { name: "L", id: 56 },
        { name: "Z", id: 57 },
        { name: "X", id: 58 },
        { name: "C", id: 59 },
        { name: "V", id: 60 },
        { name: "B", id: 61 },
        { name: "N", id: 62 },
        { name: "M", id: 63 },
        // { name: "", id: "" },
        // { name: "", id: "" },
        // { name: "", id: "" },
        // { name: "", id: "" },
        // { name: "", id: "" },
        { name: "←", id: 99 }
      ],
      plate_number: "", //车牌号
      first: "", // 中文
      numArr: [], // 英文
      HKorMacaoActype: 1
    };
  },
  methods: {
    // 唤起键盘
    clickShowKeyboard() {
      if (this.disabled) return;
      if (!this.first) {
        this.show_chinese = true;
      } else {
        this.show_chinese = false;
        this.show_allBoard = true;
      }
      this.searchRecent();
    },

    // 选择车牌号前面的汉字
    checkChinese(index) {
      // 如果点击删除键，删除第一个格的内容
      if (this.ChineseList[index].id == 99) {
        this.first = "";
      } else if (this.ChineseList[index].id == "") {
        return false;
      } else {
        // 把选中的字赋值给第一个格，并且切换键盘
        this.first = this.ChineseList[index].name;
        this.show_chinese = false;
        this.show_allBoard = true;
      }
      this.searchRecent();
    },

    // 选择车牌号后面的数字和字母
    checkEnglish_num(index) {
      // 如果点击删除键，删除 numArr 的最后一个值
      if (this.English_Number[index].id == 99) {
        if (!(this.type === "HKorMacao" && this.numArr.length == 1)) {
          this.numArr.pop();
        }
        // 如果 numArr 里面被删的没有值了，切换键盘
        if (this.numArr.length == 0) {
          this.show_chinese = true;
          this.show_allBoard = false;
        }
      } else if (this.English_Number[index].id == "") {
        return false;
      } else {
        // 把选中的值 push 到 numArr 内
        this.numArr.push(this.English_Number[index].name);
        // 普通车牌  如果 numArr 中的值超过 6 个（车牌号的最大位数），删除最后一个
        // 新能源车牌  如果 numArr 中的值超过 7 个（车牌号的最大位数），删除最后一个
        // 港澳  如果 numArr 中的值超过 6 个（车牌号的最大位数），删除最后一个
        if (this.type === "normal") {
          if (this.numArr.length === 6) {
            this.close_keyboard();
          }
          if (this.numArr.length > 6) {
            this.numArr.pop();
            this.close_keyboard();
          }
        }
        if (this.type === "newEnergy") {
          if (this.numArr.length === 7) {
            this.close_keyboard();
          }
          if (this.numArr.length > 7) {
            this.numArr.pop();
            this.close_keyboard();
          }
        }
        if (this.type === "HKorMacao") {
          if (this.numArr.length === 5) {
            this.close_keyboard();
          }
          if (this.numArr.length > 5) {
            this.close_keyboard();
          }
        }
      }
      this.searchRecent();
    },

    // 关闭虚拟键盘
    close_keyboard() {
      this.show_chinese = false;
      this.show_allBoard = false;
      // 港台车牌特殊处理
      if (this.type === "HKorMacao") {
        if (this.numArr.length === 5) {
          if (this.numArr.length === 5 && this.HKorMacaoActype == 1) {
            this.numArr.push("港");
          }
          if (this.numArr.length === 5 && this.HKorMacaoActype == 2) {
            this.numArr.push("澳");
          }
        }
        if (this.numArr.length > 5) {
          this.numArr.pop();
          if (this.numArr.length === 5 && this.HKorMacaoActype == 1) {
            this.numArr.push("港");
          }
          if (this.numArr.length === 5 && this.HKorMacaoActype == 2) {
            this.numArr.push("澳");
          }
        }
      }
      this.$emit("setLicense", this.first, this.numArr);
    },

    // 清空内容并唤起中文键盘
    emptyArray() {
      this.first = "";
      this.numArr = [];
      this.show_chinese = true;
      this.show_allBoard = false;
    },

    // 查询车牌输入缓存
    searchRecent() {
      this.$emit("searchRecent", this.first, this.numArr);
    },

    // 设置快捷选择
    setRecentUse(val) {
      this.recentUseArr = val;
    },

    // 点击具体值
    setRecentUseValue(item) {
      let arr = item.split("");
      this.first = arr[0];
      this.numArr = arr.slice(1, arr.length);
      this.searvchInfoByLicense();
    },

    // 快捷选择的车牌号快速填充信息
    searvchInfoByLicense() {
      this.$emit("searvchInfoByLicense", this.first, this.numArr);
    },

    // 港澳切换
    ChangeHKorMacaoActype(type) {
      this.HKorMacaoActype = type;
      if (
        !this.show_allBoard &&
        !this.show_chinese &&
        this.type == "HKorMacao"
      ) {
        if (this.numArr.length === 5) {
          if (this.numArr.length === 5 && this.HKorMacaoActype == 1) {
            this.numArr.push("港");
          }
          if (this.numArr.length === 5 && this.HKorMacaoActype == 2) {
            this.numArr.push("澳");
          }
        }
        if (this.numArr.length > 5) {
          this.numArr.pop();
          if (this.numArr.length === 5 && this.HKorMacaoActype == 1) {
            this.numArr.push("港");
          }
          if (this.numArr.length === 5 && this.HKorMacaoActype == 2) {
            this.numArr.push("澳");
          }
        }
      }
      this.$emit("setLicense", this.first, this.numArr);
    }
  },
  mounted() {
    if (
      !(
        String(this.licenseValue) === "" ||
        String(this.licenseValue) === "undefined"
      )
    ) {
      let arr = this.licenseValue.split("");
      this.first = arr[0];
      this.numArr = arr.slice(1, arr.length);
      if (this.type == "HKorMacao" && this.licenseValue.length == 7) {
        let HKorMacaoValue = this.numArr.splice(this.numArr.length - 1, 1)[0];
        if (HKorMacaoValue == "港") {
          this.HKorMacaoActype = 1;
        }
        if (HKorMacaoValue == "澳") {
          this.HKorMacaoActype = 2;
        }
      }
    }
  },
  watch: {
    licenseValue(val) {
      console.log(val);
      if (!(String(val) === "" || String(val) === "undefined")) {
        let arr = val.split("");
        this.first = arr[0];
        this.numArr = arr.slice(1, arr.length);
        if (this.type == "HKorMacao" && val.length == 7) {
          let HKorMacaoValue = this.numArr.splice(this.numArr.length - 1, 1)[0];
          if (HKorMacaoValue == "港") {
            this.HKorMacaoActype = 1;
          }
          if (HKorMacaoValue == "澳") {
            this.HKorMacaoActype = 2;
          }
        }
      }
    },
    type(val) {
      if (val == "HKorMacao") {
        setTimeout(() => {
          if (this.licenseValue.length == 0) {
            this.first = "粤";
            this.numArr = ["Z"];
            this.HKorMacaoActype = 1;
          }
        }, 100);
      }
    }
  }
};
</script>

<style>
.keyboard {
  /* position: absolute; */
  background: #fff;
}
.input-box li {
  font-size: 17px;
  color: #00c8d2;
  background: #e5f9fa;
  list-style: none;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 31px;
  text-align: center;
  margin: 0px 12px 2px 0px;
  vertical-align: middle;
}
.input-box li:last-child {
  border: none;
}

.class-close-box,
.allBoard .plate_number_box .close-box,
.plate_number .plate_chinese_box .close-box {
  font-size: 22px;
  position: absolute;
  right: 6px;
  top: -23px;
}

.class-close-box-div,
.allBoard .plate_number_box .close-box div,
.plate_number .plate_chinese_box .close-box div {
  width: 17px;
  height: 17px;
  font-size: 13px;
  line-height: 17px;
  margin: auto;
  text-align: center;
  border: 1px solid #666;
  border-radius: 50%;
}

.class-close-box-li,
.allBoard .plate_number_box .close-box li,
.plate_number .plate_chinese_box .close-box li {
  width: 1px;
  height: 0.5rem;
  background: #666;
  margin: auto;
}

.overflow-y,
.allBoard .van-popup,
.plate_number .van-popup {
  overflow-y: inherit;
}

.class-plate-box,
.allBoard .plate_number_box,
.plate_number .plate_chinese_box {
  width: 100%;
  /* padding: 11px 0px 0px; */
  box-sizing: border-box;
  /* background: #f4f5f6; */
  background: #fff;
  position: relative;
  text-align: left;
}

.plate_number .van-popup--bottom {
  background: #eee;
}
.plate_number .plate_chinese_box {
  width: 100%;
}
.plate_number .plate_chinese_box .van-button--small {
  width: 14.28%;
  height: 14vw;
}

.allBoard .plate_number_box {
  width: 100%;
}
.allBoard .plate_number_box .van-button--small {
  width: 10%;
  height: 10vw;
}
.displayNone {
  display: none !important;
}
.van-button--small {
  font-size: 16px;
}

/* 键盘宽高自适应 */
.plate_number_box {
  display: flex;
  width: 100%;
  text-align: center;
  align-content: center;
  flex-flow: row wrap;
}
.btn-div {
  word-break: break-all;
  border: 1px solid #f0f1f4;
  /* padding: 5px 8px; */
  vertical-align: top;
  /* flex: 13%; */
  /* width: 20%; */
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-zh {
  min-height: 54px;
  flex: 13%;
  text-align: center;
}
.btn-en {
  min-height: 54px;
  flex: 13%;
  text-align: center;
}

/* 近期使用过 */
.recent-blk {
  background: #fff;
  border-top: 1px solid #ebedf0;
  padding: 16px;
}
.recent-blk-text1 {
  padding: 0px 0px 12px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
}
.recent-scroll {
  width: 100%;
  overflow: hidden;
}
.recent-scroll nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: middle;
  -ms-flex-align: middle;
  align-items: middle;
  overflow: auto;
}
.recent-scroll div {
  flex-shrink: 0;
  font-size: 16px;
  color: #00c8d2;
  background: #e5f9fa;
  border: 1px solid #00c8d2;
  border-radius: 2px;
  padding: 3px 9px;
  margin-right: 18px;
}
/* .recent-blk-text2 {
  padding: 0px 18px 10px 0px;
  display: inline-block;
}
.recent-blk-text2-blk {
  display: inline-block;
  font-size: 16px;
  color: #00c8d2;
  background: #e5f9fa;
  border: 1px solid #00c8d2;
  border-radius: 2px;
  padding: 3px 9px;
} */
</style>
<style lang="less" scoped>
.nobg {
  background: none;
}
.HKorMacao {
  width: 60px;
  height: 30px;
  span {
    width: 30px;
    height: 30px;
    display: inline-block;
    background: #f6f6f7;
    color: #999999;
  }
  span.active {
    background: #00c8d2;
    color: #ffffff;
  }
}
</style>
